import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PencilLineOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PencilLineOutlined({
  title = 'Pencil line',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Pencil line'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M18.042.956 15.567 3.43l2.97 2.97 2.475-2.475-2.97-2.97ZM16.4 8.6l-3-3L4 15v3h3l9.4-9.4ZM1 20h22v3H1v-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PencilLineOutlined;